import HelpWidget from 'emerald-ui/lib/HelpWidget';
import chatIcon from './assets/icon-help-chat.svg';
import emailIcon from './assets/icon-help-email.svg';
import phoneIcon from './assets/icon-help-phone.svg';
import faqIcon from './assets/icon-help-faqs.svg';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: HelpWidget, componentName: 'HelpWidget' }], 'HelpWidget'),
  description: 'Displays a button and a menu at the bottom right of the window and it is used to show help links.',
  codeSamples: [
    {
      title: 'CEB specific',
      scope: { HelpWidget, chatIcon, emailIcon, phoneIcon, faqIcon },
      code: `// The following icons are real files that need to be imported

<HelpWidget id="foo-id">
  <HelpWidget.Item title="Chat" subtitle="2 min wait" icon={chatIcon} />
  <HelpWidget.Item
    title="Email"
    subtitle="30 min wait"
    icon={emailIcon}
  />
  <HelpWidget.Item
    title="Call"
    subtitle="1-877-434-6323"
    icon={phoneIcon}
  />
  <HelpWidget.Item title="FAQs" icon={faqIcon} />
</HelpWidget>`,
    },
  ],
};
